import api from '../helpers/axiosHelper';
import { API_ROOT_URL } from '../config/constant/apiConstant';
import { setAllOrgResult } from '../redux/slicers/search/searchSlicer';
import { GET_MY_ORGANIZATIONS, USER_PREFERENCE_API } from '../helpers/api';
import { profilePreferencesActions } from '../redux/slicers/profilePreferencesSlicer';
import { createGetListAction } from './apiGenerator';

export const getAllMyOrgs = (callback) => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(GET_MY_ORGANIZATIONS)
    .success((data) => {
      dispatch(setAllOrgResult(data));
      callback && callback(false);
    })
    .error(() => {
      callback && callback(false);
    })
    .send();
};

export const getPreferencesListApi = createGetListAction({
  endpoint: USER_PREFERENCE_API,
  actions: profilePreferencesActions,
  // defaultSort: 'name',
});
